import { useMemo } from 'react';
import { usePostHog } from 'posthog-js/react';
import { PostHogInstance } from 'shared/posthogCapture/types';

interface SelectedTemplateProperties {
  form_name: string;
}

export const createFormFillingCaptureEvents = (posthog: PostHogInstance) => ({
  dropdownOpened: () => {
    posthog?.capture('form filling / dropdown / opened');
  },
  dropdownSelectedTemplate: (properties: SelectedTemplateProperties) => {
    posthog?.capture('form filling / dropdown / selected template', properties);
  },
  formDownloaded: () => {
    posthog?.capture('form filling / form / downloaded');
  },
  formEdited: () => {
    posthog?.capture('form filling / form / edited');
  },
  templateRetrieved: () => {
    posthog?.capture('form filling / template / retrieved');
  },
  templateSubmitted: () => {
    posthog?.capture('form filling / template / submitted');
  },
  warningLetterGenerated: () => {
    posthog?.capture('form filling / warning letter / generated');
  },
  warningLetterSelectedAttendance: () => {
    posthog?.capture('form filling / warning letter / selected attendance');
  },
  warningLetterSelectedCustomerComplaints: () => {
    posthog?.capture(
      'form filling / warning letter / selected customer complaints'
    );
  },
  warningLetterSelectedUnprofessionalBehaviour: () => {
    posthog?.capture(
      'form filling / warning letter / selected unprofessional behaviour'
    );
  },
});

export type FormFillingCaptureEvents = ReturnType<
  typeof createFormFillingCaptureEvents
>;

export const usePosthogCapture = () => {
  const posthog = usePostHog();
  return useMemo(() => createFormFillingCaptureEvents(posthog), [posthog]);
};
